import { ServerProduct } from '@/lib/janitsjar/Product';
import NewImageCarousel from '@/components/newImageCarousel/NewImageCarousel';

export type ProductGalleryProps = {
  product: ServerProduct;
  children?: any;
};

export function ProductGallery({ product, children }: ProductGalleryProps) {
  const { media = [] } = product;

  return (
    <div className="md:col-span-6 rounded-lg relative">
      <div className="md:sticky md:top-16 print:!static">
        <NewImageCarousel
          media={
            media.length > 0
              ? media
              : [
                  {
                    type: 'image' as const,
                    id: 'no-image',
                    url: '/no_image_small.svg',
                    sortOrder: 0,
                    role: 'single_main' as const,
                    alt: 'No image',
                  },
                ]
          }
        >
          {children}
        </NewImageCarousel>
      </div>
    </div>
  );
}

export default ProductGallery;
